import { render, staticRenderFns } from "./select-group-chat.vue?vue&type=template&id=80e1fb38&scoped=true"
import script from "./select-group-chat.vue?vue&type=script&lang=js"
export * from "./select-group-chat.vue?vue&type=script&lang=js"
import style0 from "./select-group-chat.vue?vue&type=style&index=0&id=80e1fb38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e1fb38",
  null
  
)

export default component.exports